
export enum DsrLicenseCd {
	ACTIVE = 'Active',
	ACTIVE_BUT_EXPIRES_WITHIN_30_DAYS = 'ActiveButExpiresWithin30Days',
	EXPIRED = 'Expired'}
